import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Route, Switch } from 'react-router-dom'
import Event from 'components/routes/Event'
import Reservation from 'components/routes/Reservation'

import { updateReservationAndQuery } from 'actions/reservation'
import { setCurrentEventAction } from 'actions/events'
import { updateSelectLanguagesAction } from 'actions/languages'
import queryString from 'query-string'

export class EventRoutes extends React.Component {
  componentDidMount() {
    const {
      reservation,
      location,
      match,
      updateReservation,
    } = this.props
    const { data, type, id } = reservation
    const { lang, guests, start } = data
    const query = queryString.parse(location.search)

    if (!id) {
      updateReservation({ id: match.params.eventId })
    }
    if (!type) {
      updateReservation({ type: query.type || 'propose' })
    }
    if (!lang) {
      updateReservation({ data: { language: query.lang || 'en' } })
    }
    if (!guests) {
      updateReservation({ data: { guests: Number(query.guests) || 1 } })
    }
    if (!start) {
      updateReservation({ data: { start: query.date || '' } })
    }
    if (!data.coupon_code) {
      updateReservation({ data: { coupon_code: query.coupon_code || '' } })
    }

    this.fetchEventData(query.lang || 'en')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { eventsCurrentLanguage } = this.props

    if (eventsCurrentLanguage !== nextProps.eventsCurrentLanguage) {
      this.fetchEventData(nextProps.eventsCurrentLanguage)
    }
  }

  fetchEventData(language) {
    const {
      location,
      match,
      setCurrentEvent,
      updateSelectLanguages,
    } = this.props
    const query = queryString.parse(location.search)

    const { eventId, cellarId, lang } = match.params
    setCurrentEvent(eventId, language, query.guests || 1)
      .then(({ payload }) => updateSelectLanguages(payload.event.languages))
      .catch(() => {
        window.location.href = `/${lang}/${cellarId}` +
          `?lang=${query.lang}`
      })
  }

  render() {
    const { events,
      eventsCurrentLanguage,
      match } = this.props
    const { eventId } = match.params
    const event = events[eventId] && events[eventId][eventsCurrentLanguage]

    if (!event) {
      return null
    }

    return (
      <Switch>
        <Route
          exact
          path="/:lang/:cellarId/events/:eventId"
          render={(props) => {
            return (<Event
              event={event}
              match={props.match}
              history={props.history}
            />)
          }}
        />
        <Route
          exact
          path="/:lang/:cellarId/events/:eventId/reservation"
          render={(props) => {
            return (<Reservation
              event={event}
              match={props.match}
              history={props.history}
            />)
          }}
        />
      </Switch>
    )
  }
}

EventRoutes.propTypes = {
  events: PropTypes.object.isRequired,
  eventsCurrentLanguage: PropTypes.string.isRequired,
  reservation: PropTypes.object.isRequired,
  updateReservation: PropTypes.func.isRequired,
  setCurrentEvent: PropTypes.func.isRequired,
  updateSelectLanguages: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
}

function mapStateToProps(state) {
  return {
    events: state.events,
    eventsCurrentLanguage: state.languages.eventLanguage,
    reservation: state.reservation,
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    updateReservation: updateReservationAndQuery,
    updateSelectLanguages: updateSelectLanguagesAction,
    setCurrentEvent: setCurrentEventAction,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(EventRoutes)
